/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoginConfig } from '../models/LoginConfig'
import type { LoginResponse } from '../models/LoginResponse'
import type { MeResource } from '../models/MeResource'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class AuthenticationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Login Helm user using email and password, if enabled.
     * The backup login option is used when SSO is unavailable.
     * It should be disabled once SSO is set up.
     * The backup login is required to set up SSO.
     * @returns LoginResponse OK
     * @throws ApiError
     */
    public login({
        requestBody
    }: {
        /**
         * User credentials
         */
        requestBody: {
            'email'?: string
            'password'?: string
            /**
             * Required when 2FA is enabled
             */
            '2fa_code'?: string
            /**
             * Indicates a login using a trusted device
             */
            'use_safe_device'?: boolean
            /**
             * Device token for trusted device
             */
            'device_token'?: string
        }
    }): CancelablePromise<LoginResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/backup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                403: `Access Denied`,
                405: `Method not allowed.`,
                409: `2FA error`
            }
        })
    }

    /**
     * Get config required for the login page.
     * @returns any OK
     * @throws ApiError
     */
    public getLoginConfig(): CancelablePromise<{
        data: LoginConfig
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/auth/config',
            errors: {
                404: `Not Found`
            }
        })
    }

    /**
     * Invalidate token.
     * @returns any OK
     * @throws ApiError
     */
    public logout(): CancelablePromise<{
        message?: string
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/logout',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Get a new access token.
     * @returns LoginResponse OK
     * @throws ApiError
     */
    public refreshToken(): CancelablePromise<LoginResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/refresh',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                409: `Given if the token provided is not for helm`
            }
        })
    }

    /**
     * Converts an OTP to a token
     * @returns LoginResponse OK
     * @throws ApiError
     */
    public resolveToken({
        requestBody
    }: {
        /**
         * SAML2 token
         */
        requestBody: {
            /**
             * SAML2 token
             */
            auth?: string
        }
    }): CancelablePromise<LoginResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/saml2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`
            }
        })
    }

    /**
     * Get current user. Same as GET /user/{userId}.
     * @returns any OK
     * @throws ApiError
     */
    public getLoggedInUser(): CancelablePromise<{
        data: MeResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/me',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
